import { AnalyticsManager } from "@repo/analytics";

/**
 * oaStudentWeb initializes analytics before this package loads. The doubts package
 * `vite` dev server (`packages/modules/doubts/web`) does not — without this,
 * `useAnalytics()` throws ("AnalyticsManager not initialized").
 */
export function ensureDoubtsWebAnalytics(): void {
  try {
    AnalyticsManager.getInstance();
  } catch {
    const mgr = new AnalyticsManager({
      isEnabled: false,
      debugMode: true,
    });
    AnalyticsManager.setInstance(mgr);
  }
}
